export default __webpack_public_path__ + "static/media/filterIcon.0c29a970.gif";